//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { watch } from "fs";
export default {
  components: {},
  props: {
    buyMethods: {
      //購買方式參數
      required: true
    },
    discount: {
      //默認選中id
      type: Number,
      required: false,
      default: 0
    },
    priceLabel: {
      //默認選中id
      type: String,
      required: false,
      default: null
    },
    priceRate: {
      //默認選中id
      type: Number,
      required: false,
      default: 1
    }
    
  },
  data() {
    return {
      arrowIcon: require("../assets/image/icon/arrow.png"),
      settingFalseIcon: require("../assets/image/icon/icon_setting_false.png"),
      settingTrueIcon: require("../assets/image/icon/icon_setting_true.png"),
      isShow: false, // 弹窗隐藏
      selectInde: -1, // 选中下标
      useProject: {
        discount: 0,
        discountName: '',
        useType: -1
      }
    };
  },
  methods: {
    clickCell() {
      // console.log("出现弹窗");
      if (
        this.buyMethods.length > 0
      ) {
        this.isShow = !this.isShow;
      }
      // console.log(this.couponList, this.couponId);
    },
    confirm() {
      this.isShow = false;
      // console.log("確認");
      this.$emit("getProject", this.useProject);
    },
    //選中策略
    selectCoupon(e) {
      // console.log(e);
      //使用策略
      let obj;
      if (e != -1) {
        obj = this.buyMethods[e]
      } else {
        obj = {
          discount: 0,
          discountName: '',
          useType: -1
        };
      }
      this.useProject = obj;
      this.selectInde = e;
    },

    //自動選擇策略
    autoSelectCoupon() {
      console.log(this.discount,this.buyMethods);
      if (this.buyMethods.length > 0) {
        for (let i = 0; i < this.buyMethods.length; i++) {
          if (this.discount === this.buyMethods[i].discount) {
            this.selectInde = i;
            this.useProject = this.buyMethods[i];
            this.$emit("getProject", this.useProject);
          }
        }
      } else {
        // let obj = {
        //   discount: 0,
        //   discountName: '',
        //   useType: null
        // };
        this.$emit("getProject", null);
      }
    }
  },
  mounted() {
    // this.autoSelectCoupon();
  },
  watch: {
    buyMethods: {
      handler() {
        this.autoSelectCoupon();
      },
      deep: true
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/orderAvailable.vue